import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import {
  authConfigSnapshot,
  authStoreSnapshot,
} from '../../repositories/auth.repository';

@Component({
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthComponent {
  showLoginInfo = signal(authStoreSnapshot().ssoAccounts.length > 0);
  config = authConfigSnapshot();
  showAppName = signal(this.config.textMap.appName !== '');
  showBrandInfo = signal(
    this.config.textMap.appTagline !== '' ||
      this.config.textMap.appDescription !== ''
  );
}
